import React, { useState, useEffect } from 'react';
import { Checkbox, Form, Spin } from 'antd';
import styled from 'styled-components';
import Button from '../../common/Button';
import Input from '../../common/AntInput';
import Select from '../../common/Select';
import { Link } from 'react-router-dom';
import { signup, getUserEmail } from '../../../helpers/api';
import { openNotification } from '../../../helpers/notification';
import { withRouter } from 'react-router';
import ConfirmSignupModal from './ConfirmSignupModal';
import './style.css';
import { Box, CircularProgress, Grid2, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';

const { Option } = Select;

const SignupAcceptInviteForm = ({ className }) => {
  const history = useHistory();
  const searchParams = new URLSearchParams(history?.location?.search);
  const UserInviteId = searchParams.get('inviteid') || '';

  const [form] = Form.useForm();
  const nigDialCode = '+234';

  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [userRecord, setUserRecord] = useState();
  const [userLoading, setUserLoading] = useState();

  useEffect(() => {
    if (UserInviteId) {
      fetchInviteDetail();
    }
  }, [UserInviteId]);

  useEffect(() => {
    handleInitFormValues();
  }, [userRecord]);

  const handleFormatMobileNo = (mobileNo) => {
    if (mobileNo.startsWith('234')) {
      return mobileNo.slice(3);
    }
    if (mobileNo.startsWith('+234')) {
      return mobileNo.slice(4);
    }
    return mobileNo;
  };

  const handleInitFormValues = () => {
    form.setFieldsValue({
      email: userRecord?.email ?? '',
      firstname: userRecord?.firstname ?? '',
      lastname: userRecord?.lastname ?? '',
      username: userRecord?.email ?? '',
      mobileno: handleFormatMobileNo(userRecord?.mobileNo ?? ''),
    });
  };

  const fetchInviteDetail = async () => {
    setUserLoading(true);
    try {
      const res = await getUserEmail(UserInviteId);
      const { data, status } = res?.result;
      if (status?.code === '00') {
        setUserRecord(data);
      } else {
        openNotification({
          type: 'error',
          message: status?.desc,
        });
      }
    } catch (error) {
      // openNotification({
      //   type: 'error',
      //   message: 'Unable to retrieve user record',
      // });
    } finally {
      setUserLoading(false);
    }
  };

  const prefixSelector = (
    <Form.Item name="prefix" className="phone-prefix" noStyle>
      <Select
        style={{
          width: 80,
        }}
        defaultValue="+ 234"
      >
        <Option value="234">+ 234</Option>
      </Select>
    </Form.Item>
  );

  const handleSubmit = async (values) => {
    setLoading(true);

    try {
      let phoneNumber = values?.mobileno;
      if (!phoneNumber) {
        openNotification({ status: 'error', title: 'Phone number is required' });
      }

      if (phoneNumber?.charAt(0) === '0') {
        phoneNumber = phoneNumber?.slice(1);
      }

      const fullPhoneNumber = `${nigDialCode?.slice(1)}${phoneNumber}`;

      if (fullPhoneNumber?.length > 13 || phoneNumber < 13) {
        openNotification({
          type: 'error',
          title: `Phone Number (${fullPhoneNumber}) is possibly incorrect`,
        });
      }

      const payload = {
        firstname: values.firstname,
        lastname: values.lastname,
        mobileno: fullPhoneNumber,
        emailAddress: values.email,
        password: values.password,
        gender: values.gender,
        username: values.username,
      };

      //console.log('payload', payload);

      const res = await signup(payload, UserInviteId);
      const { data, status } = res?.result;
      if (status?.code === '00') {
        setVisible(true);
      } else {
        openNotification({
          type: 'error',
          title: status?.desc,
        });
      }
    } catch (error) {
      openNotification({
        type: 'error',
        title: 'Something went wrong. Please try again',
      });
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setVisible(false);
    history.push('/signin');
  };

  const handleRenderContent = () => {
    if (userLoading) {
      return (
        <Box
          height="100%"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress size={40} />
          <Typography color="textSecondary">Fetching data. Please wait...</Typography>
        </Box>
      );
    } else {
      if (!userRecord) {
        return (
          <Box
            height="100%"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Typography
              component="div"
              variant="h5"
              color="textSecondary"
              fontWeight={600}
              mb={3}
            >{`Whoops!`}</Typography>
            <Typography variant="h5">{`Invalid Invite Link.`}</Typography>
            <Typography
              variant="body2"
              color="error"
            >{`Contact an IEMS administrator for an invitation`}</Typography>
          </Box>
        );
      } else {
        return renderContent();
      }
    }
  };

  const renderContent = () => {
    return (
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Grid2 container spacing={1}>
          <Grid2 xs={12} marginBottom={5}>
            <Typography variant="h4" color="textSecondary" fontWeight={600}>
              Get Started On IEMS
            </Typography>
          </Grid2>

          <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
            <Form.Item name="email" label="Email Address" style={{ marginBottom: 0 }}>
              <Input type="email" className="signup__input" readOnly />
            </Form.Item>
          </Grid2>

          <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
            <Form.Item
              label="First Name"
              name="firstname"
              style={{ marginBottom: 0 }}
              rules={[{ required: true, message: 'please enter first name' }]}
            >
              <Input type="text" placeholder="Enter first name here" className="signup__input" />
            </Form.Item>
          </Grid2>

          <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
            <Form.Item
              label="Last Name"
              name="lastname"
              style={{ marginBottom: 0 }}
              rules={[{ required: true, message: 'please enter last name ' }]}
            >
              <Input type="text" placeholder="Enter last name here" className="signup__input" />
            </Form.Item>
          </Grid2>

          <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
            <Form.Item
              label="Username"
              name="username"
              hidden
              style={{ marginBottom: 0 }}
              rules={[{ required: true, message: 'please enter username ' }]}
            >
              <Input
                type="text"
                placeholder="Enter username here"
                className="signup__input"
                hidden
              />
            </Form.Item>
          </Grid2>

          <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
            <Form.Item
              label="Phone Number"
              className="phonenumber__input"
              name="mobileno"
              style={{ marginBottom: 0 }}
              rules={[
                ({ getFieldValue }) => ({
                  validator(rule, value) {
                    const regex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                    if (!value || (value && regex.test(value))) {
                      return Promise.resolve();
                    }
                    return Promise.reject('The input is not a valid phone number!');
                  },
                }),
              ]}
            >
              <Input
                addonBefore={prefixSelector}
                placeholder="803 999 7654"
                style={{
                  width: '100%',
                }}
              />
            </Form.Item>
          </Grid2>

          <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
            <Form.Item
              label="Gender"
              name="gender"
              style={{ marginBottom: 0 }}
              rules={[{ required: true, message: 'please select a gender  ' }]}
            >
              <Select className="signup__input">
                <Option value="m">Male</Option>
                <Option value="f">Female</Option>
              </Select>
            </Form.Item>
          </Grid2>

          <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
            <Form.Item
              label="Password"
              name="password"
              style={{ marginBottom: 0 }}
              rules={[
                ({ getFieldValue }) => ({
                  validator(rule, value) {
                    const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;
                    if (!value || (value && regex.test(value)) || value.length < 6) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      'Password should not be shorter than 6 characters and should include at least one number and one capital and small letter'
                    );
                  },
                }),
              ]}
            >
              <Input.Password
                type="password"
                className="signup__input"
                placeholder="Enter unique password"
                required
              />
            </Form.Item>
          </Grid2>

          <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
            <Form.Item
              label=""
              name="terms"
              valuePropName="checked"
              rules={[{ required: true, message: 'please agree to terms & conditions to proceed' }]}
            >
              <Checkbox required>Agree to terms & conditions</Checkbox>
            </Form.Item>
          </Grid2>

          <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
            <Form.Item>
              <Button appearance="blue" size="large" disabled={loading}>
                {loading && <Spin />} &nbsp; Sign Up
              </Button>
            </Form.Item>
            <div className="form-group signup__footer">
              <p>
                Already have an account? &nbsp;
                <Link to="/signin">Sign in now</Link>
              </p>
            </div>
          </Grid2>
        </Grid2>
      </Form>
    );
  };

  return (
    <Box sx={{ p: 5, height: '100%' }}>
      <ConfirmSignupModal open={visible} close={closeModal} />
      <br />
      {handleRenderContent()}
    </Box>
  );
};

export default styled(withRouter(SignupAcceptInviteForm))``;
